import React from 'react';
import { HealthPlanTimelineGroup } from '../../../Models/HealthPlan/HealthPlanTimelineGroup';
import useHealthPlan from '../Hooks/useHealthPlan';
import HealthPlanBabyTimeline from './HealthPlanBaby/HealthPlanBabyTimeline';
import PlanTimeline from '../../../Components/HealthPlan/PlanTimeline/PlanTimeline';

interface HealthPlanTimelineContainerProps {
	data: HealthPlanTimelineGroup[];
	onMonthClick?: (item: HealthPlanTimelineGroup) => void;
	patientId: string;
	healthPlanUser: any;
	workplaceId: string;
	reloadData: () => void;
}

const HealthPlanTimelineContainer: React.FC<
	HealthPlanTimelineContainerProps
> = props => {
	const { isBaby, isDiabetes } = useHealthPlan();
	if (isBaby) {
		return <HealthPlanBabyTimeline {...props} />;
	}
	if (isDiabetes) {
		return <PlanTimeline {...props} />;
	}
	return null;
};

export default HealthPlanTimelineContainer;
